import { useEffect, useMemo, useRef } from "react";
import type { ScrollControllerContext } from "./scroll-controller-types";

interface UseScrollContextResetInput {
  context: ScrollControllerContext;
  cancelAutoScroll: () => void;
  setShowJumpToLatest: (show: boolean) => void;
}

export function useScrollContextReset({
  context,
  cancelAutoScroll,
  setShowJumpToLatest,
}: UseScrollContextResetInput): void {
  const contextChatMode = context.chatMode;
  const contextProductId = context.productId;
  const contextKey = useMemo(
    () => ({ chatMode: contextChatMode, productId: contextProductId }),
    [contextChatMode, contextProductId],
  );
  const prevContextRef = useRef(contextKey);

  useEffect(() => {
    const prev = prevContextRef.current;
    const changed =
      prev.chatMode !== contextKey.chatMode ||
      prev.productId !== contextKey.productId;
    if (changed) {
      cancelAutoScroll();
      setShowJumpToLatest(false);
      prevContextRef.current = contextKey;
    }
  }, [contextKey, cancelAutoScroll, setShowJumpToLatest]);
}
